import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-accounting-report-tree-cell',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="account-tree-cell" [class.nested-account]="level > 0" [style.--tree-depth]="level">
            <span class="tree-guide" aria-hidden="true"></span>
            <button
                type="button"
                class="tree-toggle"
                [class.tree-toggle-placeholder]="!hasChildren"
                [attr.aria-label]="hasChildren ? (expanded ? 'Collapse ' + accountName : 'Expand ' + accountName) : null"
                [attr.aria-expanded]="hasChildren ? expanded : null"
                [disabled]="!hasChildren"
                (click)="toggle($event)">
                <i *ngIf="hasChildren" class="pi" [ngClass]="expanded ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </button>

            <div class="account-copy">
                <div class="account-title-line">
                    <span class="account-title" [class.summary-account]="summary" [class.direct-account]="direct">
                        {{ accountName }}
                    </span>
                </div>
                <div class="account-meta-line">
                    <span class="account-code">{{ accountCode || 'DIRECT' }}</span>
                    <span class="account-depth">Level {{ level + 1 }}</span>
                    <span *ngIf="childCount > 0" class="child-count">
                        {{ childCount }} {{ childCount === 1 ? 'sub-account' : 'sub-accounts' }}
                    </span>
                    <span *ngIf="direct" class="direct-badge">{{ directLabel }}</span>
                </div>
            </div>
        </div>
    `,
    styleUrls: ['./accounting-report-tree-cell.component.css']
})
export class AccountingReportTreeCellComponent {
    @Input() accountCode = '';
    @Input() accountName = '';
    @Input() level = 0;
    @Input() childCount = 0;
    @Input() expanded = false;
    @Input() summary = false;
    @Input() direct = false;
    @Input() directLabel = 'Direct activity';

    @Output() toggled = new EventEmitter<void>();

    get hasChildren(): boolean {
        return this.childCount > 0;
    }

    toggle(event: MouseEvent): void {
        event.stopPropagation();
        if (this.hasChildren) {
            this.toggled.emit();
        }
    }
}
